import config from '../config';

export interface SocialMediaPostRequest {
  platform: string;
  post_objective: string;
  target_audience: string;
  key_message: string;
  additional_context?: string;
}

export interface SocialMediaPostResponse {
  step1: string;
  step2: {
    content: string;
    hashtags: string;
  };
}

export async function generateSocialMediaPost(request: SocialMediaPostRequest): Promise<SocialMediaPostResponse> {
  try {
    console.log('Generating social media post with config:', {
      apiUrl: config.apiUrl,
      request
    });

    const response = await fetch(config.getFullUrl('/generate-social-post'), {
      method: 'POST',
      ...config.fetchOptions,
      body: JSON.stringify(request)
    });

    if (!response.ok) {
      console.error('API Error Response:', {
        status: response.status,
        statusText: response.statusText,
        headers: Object.fromEntries(response.headers.entries())
      });
      
      const errorText = await response.text();
      console.error('Error Response Body:', errorText);
      
      throw new Error(`API request failed: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    console.log('API Response:', data);
    
    return data;
  } catch (error) {
    console.error('Error generating social media post:', error);
    throw error;
  }
} 